var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.iconName,{tag:"component",staticClass:"base-icon",class:[_vm.dynamicClasses]})}
var staticRenderFns = []

export { render, staticRenderFns }